const defaultRequires = {
    weight: false,
    needed_weight: false,
    dirt: false,
    needed_dirt: false,
    gps: false,
};

const requiresFields = [
    { key: "gps", label: "Tiene posicionamiento habilitado" },
    { key: "dirt", label: "Tiene alertas bolseo habilitadas" },
    { key: "needed_dirt", label: "Tiene obligatorio indicar si hay bolseo" },
    { key: "weight", label: "Tiene que indicar peso de la isla" },
    { key: "needed_weight", label: "Tiene obligatorio indicar peso de la isla" },
];

export { defaultRequires, requiresFields };